import React from "react";
import "./german.scss";
import notvisited from "../../../assets/icons/not-visited.png";
import notanswered from "../../../assets/icons/not-answered.png";
import answered from "../../../assets/icons/answered.png";
import notanswerreview from "../../../assets/icons/not-answered-review.png";
import answerreview from "../../../assets/icons/answered-review.png";

const GermanInstruction = (props) => {
  return (
    <>
      <div className="col-md-12 test-instructions">
        <p className="msgTitle">Testanweisungen</p>
        <div>{props.instruction}</div>
        <div className="col-md-12 general-instructions">
          <p className="msgTitle">Allgemeine Anweisungen</p>
          <section>
            <ol>
              <li className="msgFont">
                Die Uhr wird auf dem Server eingestellt. Der Countdown-Timer in der
                oberen rechten Ecke des Bildschirms zeigt die verbleibende Zeit
                an, die Ihnen zur Verfügung steht, um die Prüfung zu beenden. Wenn der Timer
                null erreicht, endet die Prüfung automatisch. Sie müssen
                Ihre Prüfung nicht beenden oder einreichen.
              </li>
              <li className="msgFont">
                Die Fragenpalette auf der rechten Seite des Bildschirms zeigt
                den Status jeder Frage mit einem der folgenden Symbole an:
                <ul className="legends-listing" type="none">
                  <li className="msgFont">
                    <img src={notvisited} /> Sie haben die Frage noch nicht besucht.
                  </li>
                  <li className="msgFont">
                    <img src={notanswered} /> Sie haben die Frage nicht beantwortet.
                  </li>
                  <li className="msgFont">
                    <img src={answered} /> Sie haben die Frage beantwortet.
                  </li>
                  <li className="msgFont">
                    <img src={notanswerreview} /> Sie haben die Frage NICHT beantwortet,
                    aber die Frage zur Überprüfung markiert.
                  </li>
                  <li className="msgFont">
                    <img src={answerreview} /> Die Frage(n) "Beantwortet und
                    zur Überprüfung markiert" werden für die Bewertung berücksichtigt.
                  </li>
                </ul>
              </li>
              <li className="msgFont">
                Der Status "Zur Überprüfung markiert" für eine Frage zeigt einfach an,
                dass Sie diese Frage noch einmal ansehen möchten. Wenn eine
                Frage beantwortet und zur Überprüfung markiert ist, wird Ihre Antwort auf diese
                Frage bei der Bewertung berücksichtigt.
              </li>
              <li className="msgFont">
                Sie können auf den Pfeil klicken, der links von der
                Fragenpalette erscheint, um die Fragenpalette zu reduzieren und dadurch das
                Fragenfenster zu maximieren. Um die Fragenpalette wieder anzuzeigen, können Sie
                auf das Symbol klicken, das auf der rechten Seite des Fragenfensters erscheint.
              </li>
              <li className="msgFont">
                Sie können auf Ihr "Profil"-Bild in der oberen rechten Ecke Ihres
                Bildschirms klicken, um die Sprache während der Prüfung für den gesamten
                Fragebogen zu ändern. Beim Klicken auf das Profilbild erhalten Sie ein
                Dropdown-Menü, um den Frageninhalt in die gewünschte
                Sprache zu ändern.
              </li>
              <li className="msgFont">
                Sie können auf "Nach unten scrollen" klicken, um zum unteren Ende zu navigieren, und
                "Nach oben scrollen", um zum oberen Ende des Fragenbereichs zu navigieren, ohne
                zu scrollen.
              </li>
            </ol>
          </section>

          <section>
            <p className="msgFont">
              <b>Zu einer Frage navigieren</b>
            </p>
            <ol start="7">
              <li className="msgFont">
                Um eine Frage zu beantworten, gehen Sie wie folgt vor:
                <ol type="a">
                  <li className="msgFont">
                    Klicken Sie auf die Fragennummer in der Fragenpalette rechts
                    auf Ihrem Bildschirm, um direkt zu dieser nummerierten Frage zu gelangen.
                    Beachten Sie, dass diese Option Ihre Antwort auf die aktuelle Frage
                    NICHT speichert.
                  </li>
                  <li className="msgFont">
                    Klicken Sie auf "Speichern & Weiter", um Ihre Antwort auf die aktuelle
                    Frage zu speichern und dann zur nächsten Frage zu gehen.
                  </li>
                  <li className="msgFont">
                    Klicken Sie auf "Zur Überprüfung markieren & Weiter", um Ihre Antwort auf die
                    aktuelle Frage zu speichern, sie zur Überprüfung zu markieren und dann zur
                    nächsten Frage zu gehen.
                  </li>
                </ol>
              </li>
            </ol>
          </section>

          <section>
            <p className="msgFont">
              <b>Eine Frage beantworten</b>
            </p>
            <ol start="8">
              <li className="msgFont">
                Verfahren zum Beantworten einer Multiple-Choice-Frage:
                <ol type="a">
                  <li className="msgFont">
                    Um Ihre Antwort auszuwählen, klicken Sie auf die Schaltfläche einer der
                    Optionen.
                  </li>
                  <li className="msgFont">
                    Um Ihre gewählte Antwort abzuwählen, klicken Sie erneut auf die Schaltfläche der
                    gewählten Option oder klicken Sie auf die Schaltfläche "Antwort löschen".
                  </li>
                  <li className="msgFont">
                    Um Ihre gewählte Antwort zu ändern, klicken Sie auf die Schaltfläche einer anderen
                    Option.
                  </li>

                  <li className="msgFont">
                    Um Ihre Antwort zu speichern, MÜSSEN Sie auf die Schaltfläche
                    "Speichern & Weiter" klicken.
                  </li>
                  <li className="msgFont">
                    Um die Frage zur Überprüfung zu markieren, klicken Sie auf die Schaltfläche
                    "Zur Überprüfung markieren & Weiter". Wenn eine Antwort für eine
                    Frage ausgewählt ist, die zur Überprüfung markiert ist, wird diese Antwort
                    bei der Bewertung berücksichtigt.
                  </li>
                </ol>
              </li>
              <li className="msgFont">
                Um Ihre Antwort auf eine Frage zu ändern, die bereits
                beantwortet wurde, wählen Sie zuerst diese Frage zum Beantworten aus und
                folgen Sie dann dem Verfahren zum Beantworten dieses Fragetyps.
              </li>
              <li className="msgFont">
                Beachten Sie, dass NUR Fragen, für die Antworten gespeichert oder zur
                Überprüfung markiert wurden, nach dem Beantworten für die Bewertung berücksichtigt werden.
              </li>
            </ol>
          </section>

          <section>
            <p className="msgFont">
              <b>Durch Abschnitte navigieren</b>
            </p>
            <ol start="11">
              <li className="msgFont">
                Abschnitte in diesem Fragebogen werden in der oberen Leiste des
                Bildschirms angezeigt. Fragen in einem Abschnitt können durch Klicken auf den
                Abschnittsnamen angezeigt werden. Der Abschnitt, den Sie gerade betrachten, ist
                hervorgehoben.
              </li>
              <li className="msgFont">
                Nachdem Sie auf die Schaltfläche "Speichern & Weiter" bei der letzten Frage eines
                Abschnitts geklickt haben, werden Sie automatisch zur ersten Frage
                des nächsten Abschnitts weitergeleitet.
              </li>
              <li className="msgFont">
                Sie können während der Prüfung jederzeit zwischen Abschnitten und Fragen wechseln,
                ganz nach Ihrem Belieben, nur während der festgelegten Zeit.
              </li>
              <li className="msgFont">
                Der Kandidat kann die entsprechende Abschnittszusammenfassung als Teil
                der Legende einsehen, die in jedem Abschnitt über der
                Fragenpalette erscheint.
              </li>
            </ol>
          </section>
        </div>
      </div>
    </>
  );
};

export default GermanInstruction;